const func = $target => {
	$target.on('change', function(e) {
		document.location = this.value;
	});
};

export default func;
